var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6064 1.75594C13.0802 1.67798 12.548 1.625 12.0005 1.625C5.93588 1.625 1.00049 6.55924 1.00049 12.6246C1.00049 18.6908 5.9343 23.625 12.0005 23.625C12.5472 23.625 13.0802 23.5712 13.6064 23.4941C18.9109 22.7127 23.0002 18.144 23.0002 12.6246C23.0002 7.10669 18.9116 2.5367 13.6064 1.75594ZM19.0479 14.3101H13.6874V19.6707H13.6071H10.3165V14.3101H4.95527V10.9393H10.3165V5.57877H13.6071H13.6874V10.9393H19.0479V14.3101Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f37cc4d8.svg";
export { ForwardRef as ReactComponent };